<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "StorageEnvironmentForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        warehouse_id: null,
        storage_zone_id: null,
        parent_storage_environment_id: null,
        storage_type_id: null
      },
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        warehouse_id_options: this.$store.getters[
          "warehouse/getAll"
        ].selectOptions("id", ["internal_code", " - ", "name"]),
        // Cascade entrepôt -> zone : seules les zones de l'entrepôt choisi, libellées par leur nom.
        storage_zone_id_options: this.$store.getters["storage_zone/getAll"]
          .filter(zone => this.form.warehouse_id && zone.warehouse && zone.warehouse.id == this.form.warehouse_id)
          .selectOptions("id", "name"),
        parent_storage_environment_id_options: this.$store.getters[
          "storage_environment/getByStorageZone"
        ](this.form.storage_zone_id).selectOptions("id", "name"),
        storage_type_id_options: this.$store.getters[
          "storage_type/getAll"
        ].selectOptions("id", "name")
      };
    }
  },
  watch: {
    // Un changement d'entrepôt réinitialise la zone, sauf si elle appartient au nouvel entrepôt
    // (chargement du formulaire en modification).
    "form.warehouse_id": function(warehouse_id) {
      const zone = this.$store.getters["storage_zone/getItem"](this.form.storage_zone_id);
      if (!zone || !zone.warehouse || zone.warehouse.id != warehouse_id) {
        this.form.storage_zone_id = null;
      }
    },
    "form.storage_zone_id": function(storage_zone) {
      this.options.parent_storage_environment_id_options = this.$store.getters[
        "storage_environment/getByStorageZone"
      ](storage_zone).selectOptions("id", "name");
    }
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            warehouse_id: item.warehouse ? item.warehouse.id : null,
            storage_zone_id: item.storage_zone ? item.storage_zone.id : null,
            parent_storage_environment_id: item.parent_storage_environment
              ? item.parent_storage_environment.id
              : null,
            storage_type_id: item.storage_type ? item.storage_type.id : null
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("warehouse/getAll");
    this.$store.dispatch("storage_zone/getAllForSelect");
    this.$store.dispatch("storage_type/getAll");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/StorageEnvironment/StorageEnvironmentForm.vue